import React from 'react';
import { CheckCircle, Award, Target, Users } from 'lucide-react';
import { testimonials } from '../mock';

const About = () => {
  const values = [
    {
      icon: CheckCircle,
      title: 'Compromisso',
      description: 'Dedicação total para entregar resultados de excelência'
    },
    {
      icon: Award,
      title: 'Experiência',
      description: 'Anos de atuação no mercado imobiliário e de engenharia'
    },
    {
      icon: Target,
      title: 'Precisão',
      description: 'Processos técnicos executados com máxima atenção aos detalhes'
    },
    {
      icon: Users,
      title: 'Atendimento',
      description: 'Suporte personalizado em todas as etapas do projeto'
    }
  ];

  return (
    <section id="about" className="py-20 px-4 bg-white">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#1e3a5f' }}>
              Sobre Mim
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Sou <span className="font-semibold" style={{ color: '#c17835' }}>Hotny Mota</span>,
              analista imobiliário especializado em regularização de imóveis e projetos de engenharia.
              Com mais de uma década de experiência, ajudo proprietários e investidores a
              transformarem sonhos em realidade.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Meu trabalho vai além da documentação: proporciono segurança jurídica,
              valorização patrimonial e tranquilidade para você realizar seus projetos
              com confiança.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Seja regularização de terrenos, averbações, desdobros ou projetos
              arquitetônicos e estruturais, estou pronto para oferecer soluções
              completas e personalizadas.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <div
                  key={index}
                  className="p-6 rounded-xl text-center"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  <div className="flex justify-center mb-4">
                    <div
                      className="w-14 h-14 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#1e3a5f' }}
                    >
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                  </div>
                  <h3 className="font-bold text-lg mb-2" style={{ color: '#1e3a5f' }}>
                    {value.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-center mb-12" style={{ color: '#1e3a5f' }}>
            O Que Dizem Meus Clientes
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="p-8 rounded-xl shadow-lg"
                style={{ backgroundColor: '#f8f9fa' }}
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-5 h-5"
                      style={{ fill: '#c17835' }}
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-700 mb-4 italic">"{testimonial.content}"</p>
                <div>
                  <p className="font-bold" style={{ color: '#1e3a5f' }}>
                    {testimonial.name}
                  </p>
                  <p className="text-sm" style={{ color: '#c17835' }}>
                    {testimonial.role}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;